export default class SolicitudReclamacionesModel {
  image: string;
  title: string;
  note: string;
}